export default __webpack_public_path__ + "static/media/completed.ebc7b732.svg";